import { GppBadOutlined } from '@mui/icons-material';

import ErrorPageLayout from 'views/v2/errors/components/errorPageLayout';

export default function Unauthorized() {
    return (
        <ErrorPageLayout
            icon={<GppBadOutlined sx={{ fontSize: { xs: 34, sm: 38 } }} />}
            title="Access denied"
            description="You don't have permission to view this page. Contact your administrator if you believe this is a mistake."
            iconTone="warning"
        />
    );
}
